const caseStudiesListInit = () => {
  
  const mainPattern = document.querySelectorAll('.gg-case-studies-list');
  if (mainPattern && window.innerWidth < 480) {
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
  }
  mainPattern.forEach((module) => {
    const inputAll = module.querySelector('#all');
    const inputs = module.querySelectorAll('input[type="radio"]');
    const loadMore = module.querySelector('#load-more');
    let anyChecked = false;

    inputs.forEach(input => {
      if (input.checked) {
        anyChecked = true;
        return;
      }
    });
    if (!anyChecked) {
      if(inputAll) {
        inputAll.checked = true;
      }
    }

    const articles = module.querySelectorAll('article');
    articles.forEach((article, index) => {
      article.classList.add('fade-in-up', `delay-${index}`);
    });

    const parentElement = module.querySelector('.posts-result__container');

    const observerCallback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && !node.classList.contains('set-animation')) {
              const parent = node.parentElement;
              const childrenWithoutAnimation = Array.from(parent.children)
                .filter(child => !child.classList.contains('set-animation'));
              const index = childrenWithoutAnimation.indexOf(node);
              node.classList.add('fade-in-up', `delay-${index}`);
            }
          });
        }
      }
    };

    const observer = new MutationObserver(observerCallback);

    if (loadMore) {
      loadMore.addEventListener('click', () => {
        const newArticles = module.querySelectorAll('article');
        newArticles.forEach((article) => {
          if (article.classList.contains('fade-in-up') && !article.classList.contains('set-animation')) {
            article.classList.remove('fade-in-up');
            article.classList.add('set-animation');
          }
        });
        observer.observe(parentElement, {
          childList: true
        });
      });
    }
  });
}

caseStudiesListInit();
